import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { ActivateStepActionData } from './activate-step-action-data';
import { ArchiveFolderActionData } from './archive-folder-action-data';
import { CallApiActionData } from './call-api-action-data';
import { ChangeStepStateActionData } from './change-step-state-action-data';
import { CompleteStepActionData } from './complete-step-action-data';
import { CompleteWorkflowActionData } from './complete-workflow-action-data';
import { NodePosition } from './node-position';
import { ReminderCreationActionData } from './reminder-creation-action-data';
import { SendMailActionData } from './send-mail-action-data';
import { SendSmsActionData } from './send-sms-action-data';
import { SwitchFolderAsUnreadActionData } from './switch-folder-as-unread-action-data';
import { TimerStopActionData } from './timer-stop-action-data';
import { AnyActionData } from './Types/any-action-data';
import { UpdateAttributeActionData } from './update-attribute-action-data';

/**
 * Represente une action de workflow.
 */
export class Action {
    /**
     * Id de l'action.
     */
    public id: number;

    /**
     * Données de l'action.
     */
    public data: AnyActionData;

    // /**
    //  * Données de l'action.
    //  */
    // private _typedData: object;

    // /**
    //  * Obtient les données de l'action.
    //  */
    // public get typedData(): object {
    //     if (!this._typedData) {
    //         this._typedData = JSON.parse(this.data);
    //     }

    //     return this._typedData;
    // }

    /**
     * Constructeur.
     * @param type : Type d'action de workflow.
     * @param position : Position du noeud affichant l'action dans le designer.
     */
    public constructor(
        public type: WorkflowActionTypes,
        public position: NodePosition
    ) {}

    /**
     * Retourne une copie d'une instance d'Action
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: Action) {
        if (!!other) {
            const instance = new Action(other.type, other.position);
            instance.id = other.id;

            let dataObject = other.data;

            if (typeof dataObject === 'string') {
                dataObject = JSON.parse(dataObject);
            }

            switch (instance.type) {
                case WorkflowActionTypes.ActivateStep:
                    instance.data = ActivateStepActionData.clone(dataObject as ActivateStepActionData);
                    break;
                case WorkflowActionTypes.ApiCall:
                    instance.data = CallApiActionData.clone(dataObject as CallApiActionData);
                    break;
                case WorkflowActionTypes.ChangeStepState:
                    instance.data = ChangeStepStateActionData.clone(dataObject as ChangeStepStateActionData);
                    break;
                case WorkflowActionTypes.CompleteStep:
                    instance.data = CompleteStepActionData.clone(dataObject as CompleteStepActionData);
                    break;
                case WorkflowActionTypes.CompleteWorkflow:
                    instance.data = CompleteWorkflowActionData.clone(dataObject as CompleteWorkflowActionData);
                    break;
                case WorkflowActionTypes.SendMail:
                    instance.data = SendMailActionData.clone(dataObject as SendMailActionData);
                    break;
                case WorkflowActionTypes.UpdateAttribute:
                    instance.data = UpdateAttributeActionData.clone(dataObject as UpdateAttributeActionData);
                    break;
                case WorkflowActionTypes.SwitchFolderAsUnread:
                    instance.data = SwitchFolderAsUnreadActionData.clone(dataObject as SwitchFolderAsUnreadActionData);
                    break;
                case WorkflowActionTypes.TimerStop:
                    instance.data = TimerStopActionData.clone(dataObject as TimerStopActionData);
                    break;
                case WorkflowActionTypes.SendSms:
                    instance.data = SendSmsActionData.clone(dataObject as SendSmsActionData);
                    break;
                case WorkflowActionTypes.ReminderCreation:
                    instance.data = ReminderCreationActionData.clone(dataObject as ReminderCreationActionData);
                    break;
                case WorkflowActionTypes.ArchiveFolder:
                    instance.data = ArchiveFolderActionData.clone(dataObject as ArchiveFolderActionData);
                    break;
            }

            instance.data.id = instance.id;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances d'Action
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: Action[]) {
        if (!!others) {
            let actions: Action[] = [];

            others.forEach((x) => {
                const action = Action.clone(x);
                actions.push(action);
            });

            return actions;
        } else {
            return [];
        }
    }
}
